import {
  LOGRECORD_DETAIL_FETCHING,
  LOGRECORD_DETAIL_FAILED,
  LOGRECORD_DETAIL_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LOGRECORD_DETAIL_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case LOGRECORD_DETAIL_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case LOGRECORD_DETAIL_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
